var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-time',{attrs:{"id":"date-range","datetime":_vm.range,"name":"Date Range","rules":"required","config":{ mode: 'range', dateFormat: 'Y-m-d', minDate: 'today'}},on:{"update:datetime":function($event){_vm.range=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }